import type { Diagnostic } from "../../types";
import type { TraditionalDoc } from "./doc";

const MAX_CHAVE = 255;

/** Cada palavra precisa de uma dica de até 255 caracteres. */
export function validate(doc: TraditionalDoc): Diagnostic[] {
  const out: Diagnostic[] = [];
  for (const w of doc.palavras) {
    const chave = w.chave.trim();
    if (chave === "") {
      out.push({
        level: "error",
        message: `A palavra "${w.texto}" está sem dica.`,
        ref: w.key,
      });
    } else if (chave.length > MAX_CHAVE) {
      out.push({
        level: "error",
        message: `A dica da palavra "${w.texto}" passa de ${MAX_CHAVE} caracteres.`,
        ref: w.key,
      });
    }
  }
  return out;
}
